export const DATE_FORMAT = {
  // TODO: Extend and apply this constant https://robotsandpencils.atlassian.net/browse/AK-3262
  ISO_18601: "YYYY-MM-DD",
  US: "MM/DD/YYYY",
  US_DATE_TIME: "MM/DD/YYYY h:mma [UTC]",
  US_SHORT: "MM/DD/YY",

  COMPANY_HEADER: "MM/YYYY",
} as const

export const EMPTY_DATE_PLACEHOLDER = "--/--/----"

export const UOM_RENDER_PRECISION = 2
export const DECIMALS_PRECISION = 5
export const UOM_ROUNDING_PRECISION = 4
export const UOM_CONVERSION_PRECISION = 10
